import { dataToSendData } from "@/common/interface_api/check_send.js";
export default function(api){
    api.__createBearerApi(["g_VCode", "UMH-获取验证码"], "/v2/umh/otp/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["link_param", "msg_param", "app_key", "link_id"],
            numKey : ["notify_type", "push_type"],
        });
        return sendData;
    });
    api.__createBearerApi(["a_Organi", "UMH-添加机构"], "/v2/umh/home/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["name", "industry", "scale", "country", "addr", "dept_name", "icon"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["s_Organi", "UMH-设置机构"], "/v2/umh/home/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "name", "industry", "scale", "country", "addr", "icon"],
            numKey : ["gmt_qrcode_start", "gmt_qrcode_expire", "qrcode_expire_type", "auto_join"],
        });
        return sendData;
    });
    api.__createBearerApi(["g_Organi", "UMH-查询机构"], "/v2/umh/home/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["state", "get_menu", "get_dept", "get_tree"],
        });
        return sendData;
    });
    api.__createBearerApi(["g_OrganiDepart", "UMH-查询机构部门"], "/v2/umh/home/dept/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "home_id"],
            numKey : ["get_tree"],
        });
        return sendData;
    });

    api.__createBearerApi(["g_Member", "UMH-查询人员"], "/v2/umh/home/user/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["dept_id", "home_id","like"],
            numKey : [ "list_type", "page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["a_Member", "UMH-添加人员"], "/v2/umh/home/user/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["qrcode_key","dept_id", "home_id","note","access_pwd","addr","area","card_num","email","id_num","job_num","phone","user_icon","user_name"],
            numKey : ["op", "force","gender","gmt_end","gmt_start","list_type","remote_unlock","role_id","state","total_count","user_type"],
        });
        return sendData;
    });
    api.__createBearerApi(["s_Member", "UMH-修改人员"], "/v2/umh/home/user/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["dept_id", "id","home_id","note","access_pwd","addr","area","card_num","email","id_num","job_num","phone","user_icon","user_name"],
            numKey : ["force","gender","gmt_end","gmt_start","list_type","remote_unlock","role_id","state","total_count","user_type"],
        });
        if(data.tran_ids){
            sendData.tran_ids = data.tran_ids;
        }
        return sendData;
    });
    api.__createBearerApi(["d_Member", "UMH-删除人员"], "/v2/umh/home/user/del" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "home_id"],
            numKey : [],
        });
        sendData.ids = data.ids
        return sendData;
    });

    api.__createBearerApi(["a_OrganiDepart", "UMH-添加部门"], "/v2/umh/home/dept/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["parent_id", "home_id","name"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["s_OrganiDepart", "UMH-修改部门"], "/v2/umh/home/dept/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "home_id","name"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["d_OrganiDepart", "UMH-删除部门"], "/v2/umh/home/dept/del" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "home_id"],
            numKey : [],
        });
        return sendData;
    });
    
    api.__createBearerApi(["g_DevZone", "UMH-查询区域"], "/v2/umh/home/devloc/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["home_id"],
            numKey : ["page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["a_DevZone", "UMH-添加区域"], "/v2/umh/home/devloc/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["home_id","name"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["s_DevZone", "UMH-修改区域"], "/v2/umh/home/devloc/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "home_id","name"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["d_DevZone", "UMH-删除区域"], "/v2/umh/home/devloc/del" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "home_id"],
            numKey : [],
        });
        return sendData;
    });

    api.__createBearerApi(["g_Appr", "UMH-查询审批"], "/v2/umh/approve/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["home_id", "req_user_name"],
            numKey : ["type", "state", "page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["g_ApprDetail", "UMH-查询审批详情"], "/v2/umh/approve/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["home_id", "req_user_name"],
            numKey : ["type", "state", "page_no", "page_size"],
        });
        return sendData;
    });

    api.__createBearerApi(["s_Appr", "UMH-获取审批"], "/v2/umh/approve/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "remark", "reason"],
            numKey : ["state"],
        });
        return sendData;
    });

    api.__createBearerApi(["g_DevInfo", "IOT-获取设备信息"], "/v2/iot/uid/info/get" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["uid"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["g_Otp", "UMH-查询验证码"], "/v2/umh/otp/get" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["link_param","app_key ","link_id","ver_code"],
            numKey : ["notify_type", "push_type"],
        });
        return sendData;
    });
 









    ////// 需要抛弃的
    api.__createBearerApi(["getLicList", "UMH-获取LIC列表"], "/v2/umh/admin/liccode/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["lic_code", "grant_mac"],
            numKey : ["page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["getAppUserList", "UMH-获取角色列表"], "/v2/umh/admin/user/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id"],
            numKey : ["page_no", "page_size", "comp_id", "master_id"],
        });
        return sendData;
    });
    api.__createBearerApi_otherServer(["getAppUserList_otherAddr", "UMH-获取角色列表[其他服务器]"], "/v2/umh/admin/user/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id"],
            numKey : ["page_no", "page_size", "comp_id", "master_id"],
        });
        return sendData;
    });

    api.__createSimpleApi(["getAppUserProductList", "UMH-获取产品列表"], "/v2/umh/admin/product/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id","uid"],
            numKey : ["page_no", "page_size", ],
        });
        return sendData;
    });
    api.__createBearerApi(["getShareProduct", "UMH-获取分享商品列表"], "/v2/umh/admin/product/share/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id","node_id"],
            numKey : ["page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["addShareProduct", "UMH-新增分享商品"], "/v2/umh/admin/product/share/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["to_userid","node_id"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["delShareProduct", "UMH-删除分享列表"], "/v2/umh/admin/product/share/delete" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["delAppUserProduct", "UMH-删除产品"], "/v2/umh/admin/product/delete" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["node_id"],
            numKey : [],
        });
        return sendData;
    });

    api.__createBearerApi(["addMsgCfg", "UMH-添加消息事件配置"], "/v2/umh/admin/msg/eventcfg/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["event_name", "lang_flag"],
            numKey : ["alarm_event"],
        });
        return sendData;
    });

    api.__createBearerApi(["editMsgCfg", "UMH-设置消息事件配置"], "/v2/umh/admin/msg/eventcfg/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["event_name", "lang_flag"],
            numKey : ["id", "alarm_event"],
        });
        return sendData;
    });
    api.__createBearerApi(["delMsgCfg", "UMH-删除消息事件配置"], "/v2/umh/admin/msg/eventcfg/del" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["id"],
        });
        return sendData;
    });

    api.__createBearerApi(["getMsgCfg", "UMH-查询消息事件配置"], "/v2/umh/admin/msg/eventcfg/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["alarm_event","page_no", "page_size"],
        });
        return sendData;
    });

    api.__createBearerApi(["addMsgTemp", "UMH-添加消息事件模板"], "/v2/umh/admin/msg/template/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["lang_flag", "lang_name", "msg_format"],
            numKey : ["mode"],
        });
        return sendData;
    });

    api.__createBearerApi(["editMsgTemp", "UMH-设置消息事件模板"], "/v2/umh/admin/msg/template/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["lang_flag", "lang_name", "msg_format"],
            numKey : ["id", "mode"],
        });
        return sendData;
    });
    api.__createBearerApi(["delMsgTemp", "UMH-删除消息事件模板"], "/v2/umh/admin/msg/template/del" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["id"],
        });
        return sendData;
    });

    api.__createBearerApi(["getMsgTemp", "UMH-查询消息事件模板"], "/v2/umh/admin/msg/template/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["getUserDetail", "UMH-查询用户详细信息"], "/v2/umh/admin/user/get" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id"],
            numKey : ["sync"],
        });
        return sendData;
    });
    api.__createBearerApi(["getAlarmLog", "UMH-后台查询报警记录"], "/v2/umh/admin/alarmlog/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id","uid"],
            numKey : ["push_type","page_no","page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["getAlarmPush", "UMH-后台查询报警推送"], "/v2/umh/admin/alarmpush/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["link_id","uid","token"],
            numKey : ["push_type","send_state","page_no","page_size"],
        });
        return sendData;
    });
}